var _style, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewExpense(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1445.5 1225",
    style: {
      enableBackground: "new 0 0 1445.5 1225"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;stroke:#1A1A1A;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n\t.st1{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;stroke-dasharray:12.0596,12.0596;}\n\t.st3{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n\t.st4{fill:#FFFFFF;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n\t.st5{fill:none;stroke:#1A1A1A;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;}\n\t.st6{fill:#43418E;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n\t.st7{stroke:#1A1A1A;stroke-linecap:round;stroke-linejoin:round;}\n\t.st8{fill:none;stroke:#1A1A1A;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 171") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 698.9,
    cy: 1150.7,
    rx: 500.4,
    ry: 73.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1160.3,928.5c34.7-15,50.6-55.3,35.6-90c-2.1-4.9-4.9-9.6-8.1-13.9c20.4,3.8,42.6-7.7,51.4-26.4 c10.1-21.5,1.1-49.7-18.9-62.5s-48.3-9.9-66.2,5.7s-21,31-14.1,53.7c-14.8-6.8-27-7.3-41-3.6s-25.1,15.2-31.4,28.3 s-8.5,27.7-10,42.2c0,0-10.5,72.7,11.2,90.6C1097.5,950.9,1160.3,928.5,1160.3,928.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M94.4,847.8c0,0,0.6-2,2-5.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M100.9,830.9c27.3-63.5,148.9-280.7,509.6-203.9c414.8,88.3,661.9-148.2,595.5-426.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1204.5,194.9c-0.5-1.9-1-3.9-1.5-5.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1154.9,958.6c38.8-34.2,42.6-93.3,8.4-132.1c-4.9-5.5-10.4-10.5-16.4-14.7c28.1-3.7,52.2-27.9,55.7-56.1 c4-32.3-19.6-65.1-51-73.4s-67.1,7.5-83.7,35.4s-14.2,49.1,4.3,75.9c-22.2-2.7-38.2,1.8-54.9,12.6s-26.2,30.3-28.9,50 s0.6,39.7,4.8,59.1c0,0,17,99,52.9,113.2C1082.7,1014.3,1154.9,958.6,1154.9,958.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1140.3,706.2c0,0-71.8,62.1-91.3,305.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1060.6,915.4c0,0,36.3-33.5,88.6-29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1014.6,876c0,0,36.4,3.2,45.5,42.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1158.2,752.6c0,0-32.1,3.8-57.6,18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1100.6,710.7c0,0,12.6,13.7,12.6,33.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1046,816.6c0,0,27.1,13.8,27.1,37.7c0,0,27.8-24.5,65.1-22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.2,896.6c-25.1,23.4-63.6,21.7-84.8-1c-18.4-19.8-20.3-52-3-75.8c-33-17.9-43.7-57.7-27.9-84.8 c13.1-22.4,43.1-34.1,68.8-24.9c24.4,8.7,33.5,32.2,34.9,35.9c8-4.9,27.2-15,45.9-9c27.8,9,47.3,51.6,33.9,101.7 C501.4,858,478.8,877.3,456.2,896.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M468.7,880c-25.1,23.4-63.6,21.7-84.8-1c-18.4-19.8-20.3-52-3-75.8c-33-17.9-43.7-57.7-27.9-84.8 c13.1-22.4,43.1-34.1,68.8-24.9c24.4,8.7,33.5,32.2,34.9,35.9c8-4.9,27.2-15,45.9-9c27.8,9,47.3,51.6,33.9,101.7 C513.9,841.5,491.3,860.8,468.7,880z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M382.3,725.6c0,0,98.7,75.8,118.6,126.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M469.3,805.6c-47.7-9.2-60.9,42.2-60.9,42.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M506.3,743.2c0,0-49.7,9.3-37,62.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M386.9,766c0,0,20.9-14,37.4-5.1c-6-24,0-40.5,0-40.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1323.6,1035.5H71.8c9.3-38.1,44.6-140.4,155.3-143c136.2-3.1,171.1,100.6,171.1,100.6s50-259.8,320.3-261.9 c270.3-2.1,345.8,271.3,345.8,271.3s28.3-106.8,144.6-88S1323.6,1035.5,1323.6,1035.5z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 1.5,
    y1: 1035.5,
    x2: 1444,
    y2: 1035.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M973.7,1083.6c-8.4-8-8.4-23.4-8.4-23.4l-42.1,6.2c0,0-1.8,10.8-3.3,23.9C937.4,1097.6,960.3,1095.8,973.7,1083.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M983.6,1088.3c-3.7-0.4-7.2-2-9.9-4.6c-13.4,12.2-36.3,13.9-53.8,6.7c-2.1,18.2-3.6,41,1.1,45.8 c4.9,4.9,115,12.6,131-8.6C1067.8,1106.2,988.3,1088.8,983.6,1088.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M673.4,501.1c0,0,193.3,163.4,243.6,287.6s70.3,276.9,49.5,288.1c-16,7.9-36.8,13.8-50.6,4.9 c-4.6-3-132.9-247.8-123.5-279c-72.3-23.3-246.3-171-246.3-233.9C606.4,522.1,673.4,501.1,673.4,501.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.7,1097.5c-2-12.9,7-22.2,7-22.2l-24.6-18.3c0,0-7.4,5.3-16.6,12.4C379.5,1083.3,393.7,1093.3,408.7,1097.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M418.3,1115.1c-6.1-6.2-8.8-12.3-9.6-17.6c-14.9-4.1-29.2-14.1-34.2-28c-14.8,11.6-34.2,28.1-34.2,35.2 c0,11.5,51.3,92.7,113.2,71.8C481.4,1162.5,426.8,1123.8,418.3,1115.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M481.7,551.4c0,0,29.9,180.5,91.6,274.8c-116.5,73.3-190.9,231-190.9,231s3.1,28.9,32.5,28.9 c163.4-73.3,308.1-197,297.8-268.7c-6.4-44.1-26.3-136.3-40.7-200.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483,557.5c0,0,62.3,28.5,145,12.5c67.8-15,80.7-32.9,80.7-32.9l-11.1-14.7l-220.5,8.1L483,557.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M602.2,156.6c0,0,79.1-5,161.9-49.1s111.7-39.8,111.7-39.8l25.6,23.9c0,0-110.7,97.3-207,125.6l-96.4,28.3 L602.2,156.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M477.2,530.6c-44.7-81.7-97.9-232.3,34.4-339.6C705.4,33.7,724.3,501.4,705.9,530S498,568.6,477.2,530.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M571,54l-17.5,141.6c0,0,8.4,10.4,41.9,0c5-48.6,4.8-67.4,4.8-67.4s67.5,1.8,59.6-40.3s-18-69.2-55-69.2 C579.1,18.8,571,54,571,54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M859,79.6c0,0,27.4-26.7,48.9-13.6s8.4,41.4,8.4,41.4L859,84.1L859,79.6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st7",
    cx: 837.1,
    cy: 312.7,
    rx: 234.6,
    ry: 234.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 822.7,
    cy: 312.7,
    rx: 234.6,
    ry: 234.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 824.3,
    cy: 312.9,
    r: 214.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M768.4,507.6c0,0,58.4,0.7,57.4,11s-19.9,9.9-19.9,9.9s47.7,2.6,51.6,16.1s-36.3,23.7-65.5,11.6 s-37.1-17.8-37.1-17.8S758.8,510.3,768.4,507.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M546.1,251.9c0,0-7.2,87.7,82.7,167.6c33.7,29.9,83.1,53,141.9,78.3c7.6,28-16.2,46-16.2,46 s-83.8-3.9-182-63.2c-55.5-33.5-93.8-93.3-108.1-117.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M531.2,179c0,0,21.2-36,26.4-36s30.7,50.7,26,61.2C560.5,208.6,537.5,196.3,531.2,179z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M593.3,202c0,0-4.7-6.8,0-16.8s6.1-38,6.1-38s17.9,18.7,12.9,33.9S594.4,204.5,593.3,202z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549,95.8c0,0,31,5.8,35-4.2s-4.2-32,4.1-32s4.7,11.5,12,11.5s-4-21,9-24.1s42.8-3.7,42.8-3.7S645.1-7.9,591.2,1 S549,95.8,549,95.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M870,78.1c0,0-28.6,20.7-20,29.2s20-10,20-10s-12.6,38.1,14.9,43.6s41.3-36.5,28.3-56.1S870,78.1,870,78.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "289.5,500.5 216.7,524.8 220.7,462.6 249,453.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "180.6,416.7 253.5,392.4 249,453.2 220.7,462.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.5,437.2 251.5,419.5 249,453.2 220.7,462.6  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.7,126c6,1.6,12.2,2.4,18.5,2.3c-0.1,6.7-0.4,12.2-0.4,12.2S583.2,131.8,581.7,126z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M995.6,1077.4c0,0-14.2,25.2-9.7,28.7s22.4-19,28.1-17.3s-0.2,18.8,4.5,20.8s17.5-11,17.5-11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M430.7,1110.1c0,0-35.5,10.1-28.1,17.6s33.5-10,40.4-3s-21.9,12.9-14.2,20.6s26.2-3,26.2-3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1178.9,135.5 1179.3,184.9 1219.7,167.3  "
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st6",
    cx: 1243.4,
    cy: 561.6,
    rx: 24.9,
    ry: 24.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 208.1,
    cy: 774.4,
    rx: 24.7,
    ry: 24.7
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M847.7,372.4c2.2-7.9,0.9-16.4-3.4-23.3c-4.4-7.2-12.9-14.8-25.6-23c-17.8-10.8-29.9-22-36.4-33.7 c-6.4-11.7-7.8-24.8-4.1-39.4c3.8-14.9,11.2-26,22.2-33.3c11.1-7.3,24.4-10,40-8l7.5-29.8l20.3,5.1l-7.6,29.9 c14.7,5.9,24.9,15.3,30.7,28.2c5.8,12.8,6.3,28.5,1.6,47.1l-25-6.3c3.2-12.8,2.8-23.8-1.4-32.8c-4-9-12.1-15.5-21.7-17.5 c-10.8-2.7-19.7-2-26.9,2.1c-7.1,4.1-11.9,11.2-14.5,21.2c-2.5,8.2-1.2,17.2,3.4,24.4c4.6,7,13.3,14.5,26,22.5 c10.6,6.3,20.2,14,28.6,23c6,6.6,10.2,14.5,12.4,23.2c1.8,8.8,1.5,17.9-0.9,26.5c-3.9,15.3-11.6,26.5-23.1,33.5 c-11.6,7-25.8,9.3-42.9,6.8l-6.6,26l-20.1-5.1l6.6-26c-16.5-5.8-28.2-15.1-35.1-28c-6.9-12.9-8.1-28.3-3.6-46.2l25.1,6.4 c-3.2,12.6-2.3,23.1,2.6,31.6c4.9,8.5,13.4,14.2,25.6,17.3c11.9,3,21.9,2.5,30.2-1.5C839.9,389.1,845.8,381.4,847.7,372.4z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewExpense);
export default __webpack_public_path__ + "static/media/new-expense.eab80be018b106a8ee43c7817300e063.svg";
export { ForwardRef as ReactComponent };